import AdminRouter from "../../route/admin.route";
import React, { useState } from "react";
import {
    Layout,
    Drawer,
    Button,
    theme
} from "antd";

import {
    MenuOutlined,
    CloseOutlined,
    HomeOutlined
} from "@ant-design/icons";

import {
    Link,
    useLocation
} from "react-router-dom";

import CustomeSider from "../customSider";
import { StyleProvider } from "@ant-design/cssinjs";
import logo from "../../assets/icon/logo.png";


const { Content } = Layout;


const getPageTitle = pathname => {

    const pages = [
        ["/admin/quan-ly-nguoi-dung", "Người dùng"],
        ["/admin/quan-ly-danh-muc-trang-chu", "Danh mục trang chủ"],
        ["/admin/quan-ly-danh-muc-con", "Danh mục con"],
        ["/admin/quan-ly-danh-muc", "Danh mục"],
        ["/admin/quan-ly-san-pham", "Sản phẩm"],
        ["/admin/quan-ly-thuoc-tinh", "Thuộc tính"],
        ["/admin/quan-ly-kho-hang", "Kho hàng"],
        ["/admin/don-hang-chua-xac-nhan", "Đơn chưa xác nhận"],
        ["/admin/kiem-tra-chuyen-khoan", "Kiểm tra chuyển khoản"],
        ["/admin/quan-ly-don-hang", "Đơn hàng"],
        ["/admin/quan-ly-trang-chu", "Trang chủ"],
        ["/admin/quan-ly-ma-giam-gia", "Voucher"],
        ["/admin/quan-ly-danh-muc-blog", "Danh mục Blog"],
        ["/admin/quan-ly-blog", "Blog"],
        ["/admin/quan-ly-email-mkt", "Email MKT"],
        ["/admin/quan-ly-comment", "Bình luận"],
        ["/admin/quan-ly-make-money", "Nhiệm vụ"],
        ["/admin/quan-ly-refund-money", "Hoàn tiền"],
        ["/admin/quan-ly-rq-make-money", "Nộp nhiệm vụ"],
        ["/admin/quan-ly-request-money", "Rút tiền"],
        ["/admin/quan-ly-rq-refund-money", "Rút hoàn tiền"],
        ["/admin/cau-hinh-iframe", "Cấu hình Iframe"]
    ];


    const found =
        pages.find(
            item =>
                pathname.startsWith(
                    item[0]
                )
        );


    return found?.[1] || "Bảng tin";
};


export default function DefaultLayoutAdmin() {

    const [drawerOpen, setDrawerOpen] =
        useState(false);

    const location =
        useLocation();

    const {
        token: {
            colorBgContainer
        }
    } = theme.useToken();


    const title =
        getPageTitle(
            location.pathname
        );


    return (

        <StyleProvider hashPriority="high">

            <Layout
                className="relative"
                style={{
                    minHeight: "100vh"
                }}
            >

                {/* DESKTOP SIDEBAR */}

                <div
                    className="
                        hidden
                        lg:block

                        flex-shrink-0
                    "
                >
                    <CustomeSider />
                </div>


                {/* MOBILE DRAWER */}

                <Drawer
                    open={drawerOpen}

                    onClose={() =>
                        setDrawerOpen(false)
                    }

                    placement="left"

                    width="86%"

                    closable={false}

                    styles={{
                        body: {
                            padding: 0,
                            overflow: "auto"
                        },
                        header: {
                            display: "none"
                        }
                    }}
                >

                    <div
                        className="
                            min-h-full
                            bg-white
                        "
                        onClick={event => {

                            if (
                                event.target.closest(
                                    "a"
                                )
                            ) {
                                setDrawerOpen(false);
                            }
                        }}
                    >

                        <div
                            className="
                                sticky
                                top-0
                                z-20

                                h-16

                                bg-white

                                border-b
                                border-gray-100

                                flex
                                items-center
                                justify-between

                                px-4
                            "
                        >

                            <Link
                                to="/admin"
                                onClick={() =>
                                    setDrawerOpen(false)
                                }
                                className="
                                    flex
                                    items-center
                                    gap-3
                                "
                            >

                                <img
                                    src={logo}
                                    alt="Cửa Hàng Y Khoa"
                                    className="
                                        w-9
                                        h-9
                                        object-contain
                                    "
                                />

                                <div>
                                    <div
                                        className="
                                            text-[14px]
                                            font-bold
                                            text-gray-900
                                        "
                                    >
                                        Cửa Hàng Y Khoa
                                    </div>

                                    <div
                                        className="
                                            text-[10px]
                                            text-gray-400
                                        "
                                    >
                                        Trang quản trị
                                    </div>
                                </div>

                            </Link>


                            <Button
                                type="text"

                                icon={
                                    <CloseOutlined />
                                }

                                onClick={() =>
                                    setDrawerOpen(false)
                                }

                                className="
                                    !w-10
                                    !h-10

                                    !flex
                                    !items-center
                                    !justify-center

                                    !rounded-xl
                                "
                            />

                        </div>


                        <CustomeSider
                            mobile
                            onNavigate={() =>
                                setDrawerOpen(false)
                            }
                        />

                    </div>

                </Drawer>


                {/* CONTENT */}

                <Layout
                    className="
                        site-layout
                        min-w-0
                    "
                >

                    {/* MOBILE HEADER */}

                    <div
                        className="
                            lg:hidden

                            sticky
                            top-0
                            z-[900]

                            h-[58px]

                            bg-white/95
                            backdrop-blur

                            border-b
                            border-gray-200

                            shadow-sm

                            flex
                            items-center

                            px-3
                            gap-3
                        "
                    >

                        <Button
                            type="text"

                            icon={
                                <MenuOutlined
                                    className="
                                        text-[20px]
                                    "
                                />
                            }

                            onClick={() =>
                                setDrawerOpen(true)
                            }

                            className="
                                !w-10
                                !h-10

                                !p-0

                                !flex
                                !items-center
                                !justify-center

                                !rounded-xl

                                !bg-gray-50
                            "
                        />


                        <div
                            className="
                                flex-1
                                min-w-0
                            "
                        >

                            <div
                                className="
                                    text-[10px]
                                    text-gray-400

                                    leading-none

                                    mb-1
                                "
                            >
                                QUẢN TRỊ
                            </div>

                            <div
                                className="
                                    text-[15px]

                                    font-bold

                                    text-gray-900

                                    truncate

                                    leading-tight
                                "
                            >
                                {title}
                            </div>

                        </div>


                        <Link
                            to="/admin"

                            className="
                                w-10
                                h-10

                                rounded-xl

                                bg-blue-50

                                text-blue-600

                                flex
                                items-center
                                justify-center

                                flex-shrink-0
                            "
                        >
                            <HomeOutlined />
                        </Link>

                    </div>


                    <Content
                        className="
                            relative
                            !-z-0

                            mt-0

                            min-w-0

                            overflow-x-hidden
                        "

                        style={{
                            margin: 0,
                            padding: 0,
                            minHeight: 280,
                            background:
                                colorBgContainer
                        }}
                    >

                        <div
                            className="
                                admin-mobile-content

                                min-w-0
                                w-full
                            "
                        >
                            <AdminRouter />
                        </div>

                    </Content>

                </Layout>

            </Layout>

        </StyleProvider>
    );
}
